import { render, staticRenderFns } from "./Accommodaties.vue?vue&type=template&id=c0d7ea10&"
import script from "./Accommodaties.vue?vue&type=script&lang=js&"
export * from "./Accommodaties.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports